module.exports = __webpack_public_path__ + "static/hero2-670a05c886f1a27ef8428897f052387e.jpg";